'use client';
import React, { useEffect } from 'react'
import OneSignal from 'react-onesignal';
import { appConfig } from '../../config';

export default function OneSignalWrapper() {
  useEffect(() => {
    OneSignal.init({appId: appConfig.ONE_SIGNAL_APP_ID });
  },[])

  return <></>;
}